<div class="flex flex-wrap items-center" [style.gap.px]="rowGapPx()" #container>
  @if (firstItemTemplate()) {
    <div #firstItem>
      <ng-container [ngTemplateOutlet]="firstItemTemplate()!" />
    </div>
  }
  @for (item of visibleItems(); track $index) {
    <div #chipItem>
      <p-chip [label]="item" [styleClass]="chipStyleClass()" class="flex" />
    </div>
  }
  @if (hiddenItems().length) {
    <div #numberChip>
      <p-chip
        [label]="'+' + hiddenItems().length"
        [styleClass]="chipStyleClass()"
        class="*:hover:bg-purple-2 cursor-default flex"
        [pTooltip]="hiddenChipsTooltip"
        tooltipStyleClass="tooltip-white max-w-[30rem]"
        tooltipPosition="right"
        [autoHide]="false"
      />
    </div>
  }
  <ng-content />
</div>

<ng-template #hiddenChipsTooltip>
  <div class="flex flex-wrap items-center w-fit" [style.gap.px]="rowGapPx()">
    @for (item of hiddenItems(); let i = $index; track i) {
      <p-chip class="flex" [label]="item" [styleClass]="chipStyleClass()" />
    }
  </div>
</ng-template>
